import type { ICockpitCompletenessData, ICockpitCompletenessItem } from '../model/types'

const isSameValue = (a: string, b: string) => a.trim() === b.trim()

export const getAcknowledgedOfferingData = (
  completenessData: ICockpitCompletenessData[],
  partnerId: string,
  offering: string
): ICockpitCompletenessItem | null =>
  completenessData
    .find((item) => isSameValue(item.PartnerId, partnerId) && isSameValue(item.Offering, offering))
    ?.CompletenessData.find((item) => item.IsAcknowledged === 1) ?? null
